import { useAtomValue, useSetAtom } from 'jotai'
import { useEffect } from 'react'

import { useInstructorSelection } from './useInstructorSelection'
import { useUserManagement } from './useUserManagement'
import { availableSessionsAtom } from '../../contexts/AtomPrivateSessionSearch'
import { usePrivateSession } from '../../contexts/PrivateSessionContext'
import { instructorsAtom } from '../../domains/user/AtomUsers'
/**
 * 主要的教练预订自定义Hook，整合了教练选择和时间选择功能
 *
 * @returns {Object} - 包含状态和处理函数的对象
 */
export const usePrivateSessionSearch = () => {
  const instructors = useAtomValue(instructorsAtom)
  const { initInstructors } = useUserManagement()
  const { availableSessions, fetchAvailableSessions } = usePrivateSession()

  const setAvailableSessionsState = useSetAtom(availableSessionsAtom)

  // 初始化数据
  useEffect(() => {
    const init = async () => {
      await Promise.all([initInstructors(), fetchAvailableSessions()])
    }
    init()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setAvailableSessionsState(availableSessions)
  }, [availableSessions, setAvailableSessionsState])

  // 使用子Hook
  const instructorSelection = useInstructorSelection(availableSessions, instructors)

  return {
    // 从子Hook返回的状态和处理函数
    ...instructorSelection,

    // temp
    availableSessions,

    // 其他需要的数据
    instructors,
  }
}

export default usePrivateSessionSearch
